import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Divider,
} from "@mui/material";
import "../custom-css//TransferCertificate.css";
import { convertDateToWords } from "../utils/dateToWords";

export default function TransferCertificateState({ student, school, setTemID }) {
  const currentdate = new Date();
  const roomCount = student?.classRoom.length;
  const marksheetCount = student?.classRoom[roomCount - 1]?.marksheets.length;
  const board = student?.classRoom[roomCount - 1]?.patternType;
  const [form, setForm] = useState({});

  const receiptId = `tc-state`;

  useEffect(() => {
    if (setTemID) {
      setTemID(receiptId);
    }
    if (!student) return;

    const newForm = {
      aadharno: [student.aadharno, student.stdname].join("        2. SSSMID: "),
      studentName: toCamelCase([student.firstName, student.lastName].join(" ")),
      fatherName: toCamelCase([student.fatherName, student.lastName].join(" ")),
      motherName: toCamelCase([student.motherName, student.lastName].join(" ")),
      nationality: student.country || "",
      category: student.category || "",
      // admissionDate: student?.classRoom?.[0]?.admissionDate
      //   ? new Date(student.classRoom[0].admissionDate).toLocaleDateString("en-GB")
      //   : "",
      admissionClass: student?.classRoom?.[0]?.standard || "",
      dobDigit: student?.dateOfBirth
        ? new Date(student.dateOfBirth).toLocaleDateString("en-GB")
        : "",
      dobWord: convertDateToWords(student?.dateOfBirth),
      // lastClass: student?.classRoom?.[roomCount - 2]?.standard || "",
      // lastExam:
      //   student?.classRoom?.[roomCount - 1]?.marksheets?.[marksheetCount - 1]?.result ||
      //   "",
      // failed: student?.failed || "",
      // subjects: student?.subject || "",
      remarks: student?.remarks || "",
      paidDues: student?.paiddues || "",
      // concession: student?.concession || "",
      // totalDays: student?.workingdays || "",
      // presentDays: student?.present || "",
      nccGuide: student?.nccguide || "",
      reasonLeaving: student?.leaving || "",
      behaviour: student?.charectar || "",
      applyDate: currentdate.toLocaleDateString("en-GB"),
      issueDate: currentdate.toISOString().split("T")[0],
      promotion: student?.classRoom?.[student?.classRoom.length - 1]?.standard || "",
      games: student?.games || "",
    };

    setForm((prev) => {
      const same = JSON.stringify(prev) === JSON.stringify(newForm);
      return same ? prev : newForm;
    });
  }, [student]);



  const fields = [
    ["1. Aadhar No.", "aadharno"],
    ["2. Student's Name", "studentName"],
    ["3. Father's Name", "fatherName"],
    ["4. Mother's Name", "motherName"],
    ["5. Nationality", "nationality"],
    ["6. Whether the candidate belongs to SC/ST/OBC Category", "category"],
    ["7. Date of First Admission", "admissionDate"],
    ["7. Date of Birth (Digits)", "dobDigit"],
    ["8. Date of Birth (Words)", "dobWord"],
    ["9. Last Class Studied", "lastClass"],
    // ["10. Exam Result", "lastExam"],
    // ["11. Failed Once/Twice", "failed"],
    // ["12. Subjects Studied", "subjects"],
    ["10. Any other remarks", "remarks"],
    ["11. Whether the pupil has paid all dues to the School", "paidDues"],
    // ["15. Fee Concession", "concession"],
    // ["16. Working Days", "totalDays"],
    // ["17. Present Days", "presentDays"],
    ["12. Wheather NCC Cadet/Boy Scout/Girl Guide (detail my be given)", "nccGuide"],
    ["13. Reason for Leaving", "reasonLeaving"],
    ["14. Conduct & Behaviour", "behaviour"],
    ["15. Application Date", "applyDate"],
    ["16. Issue Date", "issueDate"],
    ["17. Promotion Class", "promotion"],
    ["18. Games/Activities", "games"],
  ];


  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <Box
      sx={{
        p: 3,
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#f3f6fc",
        minHeight: "90vh",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: "794px", // A4 width
          minHeight: "1123px", // A4 height
          p: 5,
          backgroundColor: "white",
          borderRadius: 2,
          position: "relative",
          fontFamily: "serif",
        }}
        id={receiptId}>
        {/* Header */}
        <Box textAlign="center" mb={1}>
          {/* <DescriptionIcon color="warning" sx={{ fontSize: 60 }} /> */}
          <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 0 }}>
            <img
              src={school?.logoUrl} // replace with your logo path
              alt="School Logo"
              style={{ width: 80, height: 70, marginTop: 10 }}
            />

            <Typography variant="h5" fontWeight="bold" mt={1}>
              {toCamelCase(school?.schoolName)}
            </Typography>
            <Typography variant="body2" align="center">
              {toCamelCase([school?.addressDTO?.addressLine1, school?.addressDTO?.city, school?.addressDTO?.pincode, school?.addressDTO?.state].join(", "))}
            </Typography>
            <Typography variant="subtitle2">Phone: {school?.contactPhone}</Typography>

          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography variant="body1">
              Serial No.: {student?.id}
            </Typography>
            <Typography variant="body1">DISE Code: {school?.diseCode} &nbsp;&nbsp; | &nbsp;&nbsp; Board: {board} </Typography>
            {/* <Typography variant="body1">Board: {school?.boardAffiliation}</Typography> */}
            <Typography variant="body1">
              Date: {currentdate.toLocaleDateString("en-GB")}
            </Typography>
          </Box>
          <Typography className="tc-title"
            variant="h6"
            fontWeight="bold"
            // color="warning.main"
            textTransform="uppercase"
          >
            Transfer Certificate
          </Typography>
          <Divider sx={{ my: 2 }} />
        </Box>

        {/* Form Fields */}

        <div className="tc-body">
          {fields.map(([label, value], index) => (
            <div key={index} className="tc-row">
              <p className="tc-label">{label}:</p>
              {/* <span className="tc-value">{value || "—"}</span> */}
              <TextField className="tc-value"
                variant="standard"
                value={form[value]}
                name={value}
                onChange={handleChange}
                slotProps={{
                  input: {
                    disableUnderline: true,
                    sx: { border: "none", fontSize: "0.9rem", borderBottom: '1px dotted gray', height: '1em' },
                  },
                }}
              />
            </div>
          ))}
        </div>

        {/* Footer Signatures */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 8,
            textAlign: "center",
          }}
        >
          <Box>
            <Typography variant="body1" sx={{ mb: 1 }}>
              ______________________
            </Typography>
            <Typography variant="subtitle2">(Class Teacher)</Typography>
          </Box>

          <Box>
            <Typography variant="body1" sx={{ mb: 1 }}>
              ______________________
            </Typography>
            <Typography variant="subtitle2">(Admission Incharge)</Typography>
          </Box>

          <Box>
            <Typography variant="body1" sx={{ mb: 1 }}>
              ______________________
            </Typography>
            <Typography variant="subtitle2">(Head Master)</Typography>
            <Typography variant="body2">(Seal)</Typography>
          </Box>
        </Box>

        {/* Print Button */}

      </Paper>
    </Box>
  );
}

